import type { PlatformLogoProps } from './types'
import LogoSvg from '../../assets/platform-logos/amazon.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const AmazonLogo = React.forwardRef<SVGSVGElement, PlatformLogoProps>(
  function AmazonLogo(props, ref) {
    const logoProps = getLogoProps(props, {
      primary: { light: '#484848', dark: '#ffffff' },
    })

    return <Logo {...logoProps} ref={ref} />
  },
)
